import { takeLatest, put } from 'redux-saga/effects';
import api from '../../../utils/apiConfig';
import actionTypes from './types';
import { fetchConsignmentDetailsSuccess, fetchLoadTypesSuccess, fetchLanesStart, fetchLanesSuccess } from './actions';
import urls from './urls';
import get from 'lodash/get';
import { showSnackBar } from '../../../components/UI/HOC/SnackBar/store/actions';
import { ResponseGenerator } from '../../../utils/globalContracts';

function* fetchLoadTypes() {
  const requestURL = urls.fetchLoadTypes();
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    if (response.data.success && response.data.data) {
      yield put(fetchLoadTypesSuccess(response.data.data));
    }
  } catch (e) {
    console.log({ e });
  }
}

function* fetchConsignmentDetails(action: { type: string; payload: number }) {
  const requestURL = urls.fetchConsignmentDetails(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    if (response.data.success && response.data.data) {
      yield put(fetchConsignmentDetailsSuccess(response.data.data));
      if (get(response, 'data.data.vehicleId')) {
        yield put(fetchLanesStart(get(response, 'data.data.vehicleId')));
      }
    } else {
      yield put(showSnackBar({ variant: 'error', message: response.data.message }));
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in fetching consignment data.' }));
    console.log({ e });
  }
}

function* fetchLanes(action: { type: string; payload: number }) {
  const requestURL = urls.fetchLanes(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    if (response.data.success && get(response, 'data.data.list')) {
      yield put(fetchLanesSuccess(get(response, 'data.data.list')));
    }
  } catch (e) {
    console.log({ e });
  }
}

function* updateConsignment(action: { type: string; payload: number }) {
  const requestURL = urls.updateConsignment();
  try {
    const response: ResponseGenerator = yield api.post(requestURL, action.payload);
    if (response.data.success) {
      yield put(showSnackBar({ variant: 'success', message: 'Consignment updated successfully.' }));
    } else {
      yield put(showSnackBar({ variant: 'error', message: response.data.message }));
    }
  } catch (e) {
    yield put(showSnackBar({ variant: 'error', message: 'Error in updating consignment' }));
  }
}

function* updateConsignmentSaga() {
  yield takeLatest(actionTypes.FETCH_LOAD_TYPES_START, fetchLoadTypes);
  yield takeLatest(actionTypes.FETCH_CONSIGNMENT_DETAILS_START, fetchConsignmentDetails);
  yield takeLatest(actionTypes.FETCH_LANES_START, fetchLanes);
  yield takeLatest(actionTypes.UPDATE_CONSIGNMENT, updateConsignment);
}
export default updateConsignmentSaga;
